import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { compress, decompress } from 'lz-string'
import { ReactNode, useEffect } from 'react'
import { useTRPC } from '~/services/trpc'

import { DatastoreContext } from './context'

const cache = window.localStorage.getItem('datastore')
const initialData = cache ? JSON.parse(decompress(cache)) : null

export function DatastoreProvider(props: { children?: ReactNode }) {
  const trpc = useTRPC()
  const { data, isPending } = useQuery(
    trpc.lookup.getFilterData.queryOptions(
      {},
      {
        initialData: initialData,
        placeholderData: keepPreviousData,
      },
    ),
  )
  useEffect(() => {
    if (data) window.localStorage.setItem('datastore', compress(JSON.stringify(data)))
  }, [data])

  return (
    <DatastoreContext.Provider
      value={{ data: data || {}, isLoading: isPending, isInitialLoading: !initialData }}
    >
      {props.children}
    </DatastoreContext.Provider>
  )
}

export * from './hooks'
